import { Component, OnInit } from '@angular/core';

import { AppStatisticalFormUser } from 'src/app/core/types/app-statistical-form-user.type';

@Component({
    selector: 'app-send-count-statistics',
    templateUrl: './send-count-statistics.component.html',
    standalone: false
})
export class SendCountStatisticsComponent implements OnInit {

  title: string = "pages.sentCountStatistics.title";
  doughnutChartId: string = "doughnut_sentCountStatistics"
  barChartId: string = "bar_sentCountStatistics"
  getDailyItemsApiMethodName: string = "statisticsGetSentCountDailyStatisticsByUserId";
  getMonthlyItemsApiMethodName: string = "statisticsGetSentCountMonthlyStatisticsByUserId";
  userType: AppStatisticalFormUser = "usersListByOrganizationId";

  constructor() { }

  ngOnInit(): void { }

}
